<template>
  <div class="sifa-cont-right">
    <div class="personbox">
      <h2>发票管理-开具发票</h2>
      <div class="sub-page"></div>
      <el-table :data="invoiceList" style="width: 100%" :cell-style='styleCenter' :header-cell-style='styleCenter'>
        <el-table-column prop="invoiceTitle" label="发票抬头" :show-overflow-tooltip="true" align="center"></el-table-column>
        <el-table-column label="费用类型" align="center">
          <template slot-scope="scope">
            <div v-if="scope">软件使用费</div>
          </template>
        </el-table-column>
        <el-table-column prop="recipientsPhone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="email" label="电子邮箱" :show-overflow-tooltip="true" align="center"></el-table-column>
        <el-table-column prop="invoiceNote" label="发票备注" :show-overflow-tooltip="true" align="center"></el-table-column>
        <el-table-column prop="money" label="开票金额(元)" align="center"></el-table-column>
        <el-table-column prop="createTime" label="申请开票时间" width="125" :show-overflow-tooltip="true" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope" @click='openDialog(scope.row)'>查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom-page-div">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="查看详情" :visible.sync="platformDialog" :append-to-body="true">
      <div style="padding-bottom: 40px;">
        <span style="font-size: 16px;color: black;font-weight: 600;">缴纳费用：</span>
        <span style="font-size: 28px;color: #D9001B;">￥{{platformSumPrice}}</span>
      </div>
      <el-table :data="tableDataX" style="width: 100%" :cell-style='styleCenter' :header-cell-style='styleCenter'>
        <el-table-column label="序号" type="index" :index="indexMethod" width="55px"></el-table-column>
        <el-table-column prop="orderNo" label="订单编号" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="lotName" label="标的名称" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="费用类型" align="center">
          <template slot-scope="scope">
            <div v-if="scope">软件使用费</div>
          </template>
        </el-table-column>
        <el-table-column prop="platformPayTime" label="缴纳时间" align="center"></el-table-column>
        <el-table-column prop="platformCost" label="订单金额(元)" align="center"></el-table-column>
      </el-table>
      <div style="text-align: end;margin-right: 20px;padding-bottom: 20px;">
        <el-pagination @size-change="handleSizeChangeX" @current-change="handleCurrentChangeX" :current-page="pageX.currentPage" :page-sizes="[10, 20, 40]" :page-size="pageX.pageSize" layout="total, sizes, prev, pager, next, jumper" :total=totalX>
        </el-pagination>
      </div>
      <div style="text-align:center">
        <el-button @click="platformDialog=false" type="primary" style="min-width: 120px;">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getList, cmsInvoiceWinLotDetail } from '@/api/biz/auction/invoiceInfo'
export default {
  name: 'InvoiceHistoryView',
  data() {
    return {
      styleCenter: { 'text-align': 'center' },
      invoiceList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      pageX: {
        pageSize: 10,
        currentPage: 1,
      },
      totalX: 0,
      tableDataX: [],
      platformDialog: false,
      showForm: {},
      rules: {
        invoiceTitle: [{ required: true, message: '请输入发票抬头', trigger: 'change' }],
        taxpayerNum: [{ required: true, message: '请输入纳税人识别号', trigger: 'change' }],
        recipientsPhone: [{ required: true, message: '请输入收件人手机号', trigger: 'change' }],
        email: [{ required: true, message: '请输入电子邮箱', trigger: 'change' },
        { type: 'email', message: '邮箱格式不正确，请重新输入', trigger: 'blur' }],
      },
      platformSumPrice: 0
    }
  },
  computed: { ...mapGetters(["userInfo"]) },
  created() {
    this.queryData(this.page);
  },
  methods: {
    openDialog(row) {
      console.log('row', row)
      this.showForm = row;
      this.platformDialog = true;
      this.ids = row.id
      this.platformSumPrice = row.money
      this.newMessage(this.pageX, row.id)
    },
    queryData(page) {
      getList(page.currentPage, page.pageSize, { bidderId: this.userInfo.user_id }).then(res => {
        const data = res.data.data;
        this.invoiceList = data.records;
        this.page.total = data.total;
      })
    },
    newMessage(page, id) {
      cmsInvoiceWinLotDetail(page.currentPage, page.pageSize, { biiId: id }).then(res => {
        const data = res.data.data;
        this.tableDataX = data;
        this.totalX = data.length;
      })
    },
    handleSizeChangeX(val) {
      this.pageX.pageSize = val;
      this.newMessage(this.pageX, this.ids);
    },
    handleCurrentChangeX(val) {
      this.pageX.currentPage = val;
      this.newMessage(this.pageX, this.ids);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.queryData(this.page);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.queryData(this.page);
    },
    indexMethod(index) {
      return index + 1;
    },
  },
}
</script>

<style scoped>
::v-deep .el-dialog__header {
  background-color: rgb(59, 133, 244);
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
::v-deep .el-dialog__title {
  color: #fff;
  font-size: 18px;
}
::v-deep .el-table {
  padding: 0 15px;
  margin-bottom: 10px;
}
::v-deep .el-table th.el-table__cell {
  background-color: rgb(236, 245, 255);
}
::v-deep .el-table thead {
  font-size: 16px;
  color: rgb(59, 133, 244);
}
.bottom-page-div {
  text-align: end;
  margin-right: 20px;
}
.personbox {
  margin: 0 0 40px;
  background-color: #fff;
  display: block;
  min-height: 380px;
}
.personbox h2 {
  height: 30px;
  line-height: 30px;
  background: #e9e9e9;
  color: #424242;
  padding-left: 20px;
  font-size: 14px;
  font-weight: 400;
}
.sub-page {
  margin-left: 15px;
  font-size: 16px;
  color: rgb(0, 0, 0);
  padding: 2% 0;
}
</style>